import { render } from "./Acknowledgement.vue?vue&type=template&id=f30fbc80"
import script from "./Acknowledgement.vue?vue&type=script&lang=js"
export * from "./Acknowledgement.vue?vue&type=script&lang=js"

import "./Acknowledgement.vue?vue&type=style&index=0&id=f30fbc80&lang=less"
import "./Acknowledgement.vue?vue&type=style&index=1&id=f30fbc80&lang=less"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/collections/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__